import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { get, uniqueId } from 'lodash';
import { SdfAlert, SdfBusyIndicator, SdfButton, SdfDatePicker, SdfFocusPane } from '@synerg/react-components';
import Toast from '../../common/toast';
import { getFormattedDateFromString } from '../../common';

export default function ExportUsage(props) {
  const { partnerOOID, close, openModal } = props;
  const [isBusy, setBusy] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [toast, setToast] = useState(false);
  const currentDate = new Date();
  const selectedFormattedDate = selectedDate ? new Date(getFormattedDateFromString(selectedDate)) : null;
  let selectedDateGreater = false;

  const handleResponse = (message, status = "error") => {
    setToast({
      key: uniqueId(),
      status: status,
      message: message,
      showToast: true
    });
  };

  const closeModal = () => {
    close();
    setSelectedDate(false);
  };

  const onDownloadClick = async () => {
    try {
      setBusy(true);
      const params = {
        ...(partnerOOID && { partnerOOID }),
        transactionMonth: selectedDate.replace(/-/g, ""),
        mode: 'zipfile'
      };
      const { data: { fileUrl } } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/datacloud/graph-data`, { params });
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', `api-usage-${selectedDate}.zip`);
      document.body.appendChild(link);
      link.click();
      setBusy(false);
      closeModal();
      handleResponse("Your CSV report was downloaded successfully.", "success");
    } catch (e) {
      if (e) {
        const errorMessage = get(e, 'response.data.message', 'Something went wrong when trying to retrieve billable API transaction history. Please try again.');
        setBusy(false);
        closeModal();
        handleResponse(errorMessage);
      }
    }
  };

  if (selectedFormattedDate && (selectedFormattedDate.getFullYear() >= currentDate.getFullYear() && selectedFormattedDate.getMonth() + 1 >= currentDate.getMonth() + 1)) {
    selectedDateGreater = true;
  }


  return (<>
    {toast && <Toast
      key={toast.key}
      status={toast.status}
      message={toast.message}
      showToast={toast.showToast}
    />}
    <SdfFocusPane
      paneType="floating"
      visible={openModal}
      size="small"
      onSdfDismiss={() => closeModal()}
      closeable={!isBusy && true}
      hideAcceptButton={true}
      hideDismissButton={true}
      heading="Export"
    >
      <div className="px-4 pb-4">
        <div className="text-heading-04 font-bold">Export API transaction history</div>
        <div className="text-body-02 mt-4">Start by selecting the month and year you would like to download as a CSV. Please note the current month cannot be downloaded.</div>
        <div style={{ height: "18rem" }}>
          {isBusy ?
            <SdfBusyIndicator className='py-20' size='xl'></SdfBusyIndicator>
            :
            <div className="flex justify-center pt-10">
              <SdfDatePicker
                className="w-9/12"
                label="Report for"
                placeholder={"mm/yyyy"}
                value={selectedDate || ''}
                onSdfChange={(date) => setSelectedDate(date.detail)}
                yearMonth={true}
              >
                {selectedDateGreater && <SdfAlert
                  className=''
                  slot="alert"
                  size="sm"
                  status="error"
                  type="inline"
                >
                  Please select a valid month
                </SdfAlert>}
              </SdfDatePicker>
            </div>
          }
        </div>
      </div>

      <div slot="custom-buttons" >
        <SdfButton
          onClick={closeModal}
          {...isBusy && { disabled: true }}
        >
          Cancel
        </SdfButton>

        <SdfButton
          emphasis="primary"
          onClick={() => onDownloadClick()}
          className="ml-3"
          {...(isBusy || !selectedDate || selectedDateGreater) && { disabled: true }}
        >
          <div style={{ height: '1.625rem' }}>
            Download as CSV
          </div>
        </SdfButton>
      </div>
    </SdfFocusPane>
  </>);
}
